<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>会员等级管理</span>
      <el-button v-if="$hasPermission('mall:member-level:save')" type="primary" size="mini" @click="openCreate">新增等级</el-button>
    </div>

    <div class="search-bar search-wrap">
      <el-input v-model.trim="query.levelName" placeholder="请输入等级名称" clearable style="width: 240px" @keyup.enter.native="handleSearch" />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column label="图标" width="90" align="center">
        <template slot-scope="{ row }">
          <el-image
            v-if="row.levelIconUrl"
            :src="resolveFileUrl(row.levelIconUrl)"
            :preview-src-list="[resolveFileUrl(row.levelIconUrl)]"
            fit="cover"
            class="level-icon"
          >
            <div slot="error" class="level-icon-empty">无图</div>
          </el-image>
          <div v-else class="level-icon-empty">无图</div>
        </template>
      </el-table-column>
      <el-table-column prop="levelCode" label="等级编码" width="130" />
      <el-table-column prop="levelName" label="等级名称" min-width="120" />
      <el-table-column prop="minPoints" label="积分下限" width="120" align="right" />
      <el-table-column prop="maxPoints" label="积分上限" width="120" align="right" />
      <el-table-column prop="discountRate" label="兑换折扣" width="110" align="center">
        <template slot-scope="{ row }">{{ formatDiscount(row.discountRate) }}</template>
      </el-table-column>
      <el-table-column prop="signInPoints" label="签到积分" width="110" align="right" />
      <el-table-column prop="status" label="状态" width="90" align="center">
        <template slot-scope="{ row }">{{ row.status === 1 ? '启用' : '禁用' }}</template>
      </el-table-column>
      <el-table-column prop="sortNum" label="排序" width="90" align="right" />
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-if="$hasPermission('mall:member-level:update')" size="mini" @click="openEdit(row)">编辑</el-button>
          <el-button
            v-if="$hasPermission('mall:member-level:update')"
            :type="row.status === 1 ? 'warning' : 'success'"
            size="mini"
            @click="toggleStatus(row)"
          >
            {{ row.status === 1 ? '禁用' : '启用' }}
          </el-button>
          <el-button v-if="$hasPermission('mall:member-level:delete')" size="mini" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="form.id ? '编辑等级' : '新增等级'" :visible.sync="dialogVisible" width="720px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="等级编码" prop="levelCode">
          <el-input v-model.trim="form.levelCode" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item label="等级名称" prop="levelName">
          <el-input v-model.trim="form.levelName" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item label="等级图标">
          <image-selector
            v-model="form.levelIconUrl"
            :category-code.sync="form.levelIconCategoryCode"
            :allowed-categories="['member-level-icon']"
          />
        </el-form-item>
        <el-form-item label="积分下限" prop="minPoints">
          <el-input-number v-model="form.minPoints" :min="0" :precision="0" :disabled="!!form.id" style="width: 100%" />
        </el-form-item>
        <el-form-item label="积分上限" prop="maxPoints">
          <el-input-number v-model="form.maxPoints" :min="0" :precision="0" :disabled="!!form.id" style="width: 100%" />
        </el-form-item>
        <el-form-item label="兑换折扣" prop="discountRate">
          <el-input-number v-model="form.discountRate" :min="1" :max="10" :step="0.1" :disabled="!!form.id" style="width: 100%" />
          <div class="form-tip">10 表示不打折，9 表示九折。</div>
        </el-form-item>
        <el-form-item label="签到积分" prop="signInPoints">
          <el-input-number v-model="form.signInPoints" :min="0" :precision="0" style="width: 100%" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortNum" :precision="0" :disabled="!!form.id" style="width: 100%" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="$hasPermission(form.id ? 'mall:member-level:update' : 'mall:member-level:save')" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'
import ImageSelector from '../../components/mall/ImageSelector.vue'
import { resolveFileUrl } from '../../utils/file'

function defaultQuery () {
  return { page: 1, limit: 10, levelName: '' }
}

function defaultForm () {
  return {
    id: null,
    levelCode: '',
    levelName: '',
    levelIconUrl: '',
    levelIconCategoryCode: 'member-level-icon',
    minPoints: 0,
    maxPoints: 0,
    discountRate: 10,
    signInPoints: 0,
    sortNum: 0,
    status: 1
  }
}

export default {
  components: {
    ImageSelector
  },
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        levelCode: [{ required: true, message: '请输入等级编码', trigger: 'blur' }],
        levelName: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
        minPoints: [{ required: true, message: '请输入积分下限', trigger: 'blur' }],
        maxPoints: [{ required: true, message: '请输入积分上限', trigger: 'blur' }],
        discountRate: [{ required: true, message: '请输入兑换折扣', trigger: 'blur' }],
        signInPoints: [{ required: true, message: '请输入签到积分', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    resolveFileUrl,
    async load () {
      const { data } = await http.get('/mall/member-level/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    openCreate () {
      this.form = defaultForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    async openEdit (row) {
      const { data } = await http.get(`/mall/member-level/info/${row.id}`)
      this.form = { ...defaultForm(), ...(data.data || {}), levelIconCategoryCode: 'member-level-icon' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    toggleStatus (row) {
      const nextStatus = row.status === 1 ? 0 : 1
      const actionText = nextStatus === 1 ? '启用' : '禁用'
      this.$confirm(`确定${actionText}会员等级“${row.levelName}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data: infoResult } = await http.get(`/mall/member-level/info/${row.id}`)
        const payload = { ...defaultForm(), ...(infoResult.data || {}), status: nextStatus }
        const { data } = await http.post('/mall/member-level/update', payload)
        if (data.code === 0) {
          this.$message.success(`会员等级${actionText}成功`)
          this.load()
        }
      })
    },
    save () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (Number(this.form.maxPoints) < Number(this.form.minPoints)) {
          this.$message.error('积分上限不能小于积分下限')
          return
        }
        const url = this.form.id ? '/mall/member-level/update' : '/mall/member-level/save'
        const { data } = await http.post(url, this.form)
        if (data.code === 0) {
          this.$message.success(this.form.id ? '会员等级修改成功' : '会员等级新增成功')
          this.dialogVisible = false
          this.load()
        }
      })
    },
    remove (row) {
      this.$confirm(`确定删除会员等级“${row.levelName}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/member-level/delete', [row.id])
        if (data.code === 0) {
          this.$message.success('会员等级删除成功')
          this.load()
        }
      })
    },
    formatDiscount (value) {
      const rate = Number(value || 10)
      return rate <= 10 ? `${rate}折` : `${rate}%`
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.level-icon,
.level-icon-empty {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.level-icon {
  border: 1px solid #ebeef5;
  cursor: pointer;
}

.level-icon-empty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #f5f7fa;
  font-size: 12px;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.form-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}
</style>
